function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  id: "a",
  d: "M25.072 29.017l3.01-5.258a4.5 4.5 0 0 1 6.883-1.14V9.5a1.5 1.5 0 0 0-1.5-1.5H27.49v5.486a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5V8H9.5A1.5 1.5 0 0 0 8 9.5v18.017a1.5 1.5 0 0 0 1.5 1.5h15.572zm-1.717 3H9.5a4.5 4.5 0 0 1-4.5-4.5V9.5A4.5 4.5 0 0 1 9.5 5h23.965a4.5 4.5 0 0 1 4.5 4.5v17.832l4.825 8.324a4.5 4.5 0 0 1-3.893 6.757H25.164a4.5 4.5 0 0 1-3.905-6.736l2.096-3.66zM24.49 8h-6v2.986h6V8zm-12 17.986a1.5 1.5 0 1 1 0-3h3a1.5 1.5 0 0 1 0 3h-3zm18 3a1.5 1.5 0 0 1 3 0v3a1.5 1.5 0 1 1-3 0v-3zm-6.627 8.182a1.5 1.5 0 0 0 1.301 2.245h13.733a1.5 1.5 0 0 0 1.298-2.252l-6.91-11.918a1.5 1.5 0 0 0-2.599.007l-6.823 11.918zm8.127.818a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"
});

var SvgProblem = function SvgProblem(props) {
  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref);
};

export default SvgProblem;


//////////////////
// WEBPACK FOOTER
// ./src/icons/shipment-status/problem.svg
// module id = 134
// module chunks = 0 1